import { Link, Outlet } from 'react-router-dom';

const Layout = () => {
    return (
        <>
            <header className='flex justify-center'>
                <Link className='mr-3' to="/">Home</Link>
                <Link className='mx-3' to="/about">About</Link>
                <Link className='mx-3' to="/forms">Forms</Link>
            </header>
            <Outlet />
        </>
    )
}

export default Layout